import React from 'react';
import PropTypes from 'prop-types';

import {cn} from 'spa/css';

import './ContextualMenu.less';

class ContextualMenu extends React.Component {
  static propTypes = {
    greenMode: PropTypes.bool,
  }

  render() {
    const {greenMode} = this.props;

    return (
      <div
        id={greenMode ? 'js-context-overlay-green' : 'js-context-overlay'}
        className={cn(
          'contextualMenu__overlay',
          greenMode && 'contextualMenu__overlay--green',
        )}
      >
        <div
          id={greenMode ? 'js-context-menu-green' : 'js-context-menu'}
          className="contextualMenu__panel"
        >
          <div
            id="js-context-entry-point"
            className="contextualMenu__sub-menu"
          />
        </div>
      </div>
    );
  }
}

export default ContextualMenu;



// WEBPACK FOOTER //
// ./spa/Components/ContextualMenu.jsx